export default [
  {
    title: `Exceed Client Expectations`,
    alt: 'exceed client expectations for carpet cleaning',
    description: `Create a perfect portrait of a prospect's space, even without internet.`,
    icon: 'walkthroughBuilder'
  },
  {
    title: `Precise, Profitable Bidding`,
    alt: 'accurate carpet cleaning bids',
    description: `Improved carpet cleaning bid accuracy with or without a completed walkthrough.`,
    icon: 'estimator'
  },
  {
    title: `Close More Deals`,
    alt: 'close more carpet cleaning deals',
    description: `Impress prospects with professional proposals perfectly tailored to them.`,
    icon: 'proposalGenerator'
  }
  // {
  //   title: `Complete Job Transparency`,
  //   description: `No more confusion about jobs and confirm completed work at a glance.`,
  //   icon: 'workflowManagement'
  // }
]
